import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IPaginatedResponse, IStripePlan } from "../../interfaces";

export const useStripePlans = () => {
  return useQuery<IPaginatedResponse<IStripePlan>, Error>({
    queryKey: ["stripe", "plans"],
    queryFn: async () => {
      const response = await httpService.get<IPaginatedResponse<IStripePlan>>(
        API_CONFIG.path.stripePlans
      );
      return response;
    },
  });
};
